const searchEvents: StandardObjectInterface = {
    updateSearch: 'update-search',
    updatePagination: 'search-update-pagination',
    updateSearchMap: 'update-search-map',
    searchCompleted: 'search-completed',
    removeSelectedDateFilters: 'remove-selected-date-filters'
};

export default searchEvents;
